import PropTypes from 'prop-types';
import React from 'react';
import { useIMask } from 'react-imask';

import BaseInput from 'components/shared/controls/BaseInput';

const MaskInput = ({ disabled, mask, blocks, value, onBlur, onChange, ...restProps }) => {
  const handleAccept = (value) => {
    onChange && onChange({ target: { value } });
  };

  const { ref, value: _value } = useIMask({ mask, blocks }, { onAccept: handleAccept });

  return (
    <BaseInput
      ref={ref}
      disabled={disabled}
      value={_value || value}
      onBlur={onBlur}
      onChange={() => {}}
      {...restProps}
    />
  );
};

MaskInput.propTypes = {
  disabled: PropTypes.bool,
  mask: PropTypes.string,
  blocks: PropTypes.object,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default MaskInput;
